import { render, staticRenderFns } from "./HetSection.vue?vue&type=template&id=610bd59d"
import script from "./HetSection.vue?vue&type=script&lang=js"
export * from "./HetSection.vue?vue&type=script&lang=js"
import style0 from "./HetSection.vue?vue&type=style&index=0&id=610bd59d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports